import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Logo from "../Logo/Logo";
import { fetchCategories } from "../../api/newsApi";
import "./Footer.css";

function Footer() {
  const [categories, setCategories] = useState([]);

  useEffect(() => {
    let isMounted = true;

    async function loadCategories() {
      try {
        const data = await fetchCategories();
        if (isMounted) setCategories(Array.isArray(data) ? data.slice(0, 6) : []);
      } catch (err) {
        if (isMounted) setCategories([]);
      }
    }

    loadCategories();
    return () => {
      isMounted = false;
    };
  }, []);

  const year = new Date().getFullYear();

  return (
    <footer className="tt-footer-wrap">
      <div className="tt-footer-inner">
        <div className="tt-footer-brand">
          {/* <div className="tt-footer-logo-box"> */}
          <Logo size="large" />
          {/* </div> */}
          <p className="tt-footer-tagline">
            Your trusted source for the latest news and in-depth reporting from around the world.
          </p>
        </div>

        <div className="tt-footer-columns">
          <div className="tt-footer-col">
            <h3 className="tt-footer-col-title">Company</h3>
            <ul>
              <li>
                <a href="mailto:todaytalks.office@gmail.com" className="tt-footer-link">
                  Contact
                </a>
              </li>
            </ul>
          </div>

          {categories.length > 0 && (
            <div className="tt-footer-col">
              <h3 className="tt-footer-col-title">Categories</h3>
              <ul>
                {categories.map((category) => (
                  <li key={category.id}>
                    <Link to={`/category/${category.slug}`} className="tt-footer-link">
                      {category.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          )}

          <div className="tt-footer-col">
            <h3 className="tt-footer-col-title">Legal</h3>
            <ul>
              <li>
                <Link to="/privacy-policy" className="tt-footer-link">
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link to="/terms-of-service" className="tt-footer-link">
                  Terms of Service
                </Link>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div className="tt-footer-bottom">
        <p className="tt-footer-copyright">&copy; {year} TodayTalks. All rights reserved.</p>

        <div className="tt-footer-social">
          <a href="https://www.facebook.com/profile.php?id=61563928347546#" target="_blank" rel="noreferrer" aria-label="Facebook" className="tt-footer-social-icon">
            <svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true">
              <path
                d="M15 8.5h2V5.5h-2c-2.2 0-4 1.8-4 4V11H9v3h2v6h3v-6h2.4l.6-3H14V9.5c0-.6.4-1 1-1z"
                fill="currentColor"
              />
            </svg>
          </a>
          <a href="https://www.youtube.com/channel/UCrPb4cMJS9FqHIgv4_HwMEA" target="_blank" rel="noreferrer" aria-label="YouTube" className="tt-footer-social-icon">
            <svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true">
              <rect x="3" y="6" width="18" height="12" rx="3" fill="none" stroke="currentColor" strokeWidth="1.6" />
              <path d="M10 9.5l6 2.5-6 2.5v-5z" fill="currentColor" />
            </svg>
          </a>
          <a href="https://www.instagram.com/todaytalks4/" target="_blank" rel="noreferrer" aria-label="Instagram" className="tt-footer-social-icon">
            <svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true">
              <rect x="3.5" y="3.5" width="17" height="17" rx="5" fill="none" stroke="currentColor" strokeWidth="1.6" />
              <circle cx="12" cy="12" r="4" fill="none" stroke="currentColor" strokeWidth="1.6" />
              <circle cx="17.2" cy="6.8" r="1.1" fill="currentColor" />
            </svg>
          </a>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
